<template>
  <v-container class="px-4 px-sm-0">

    <v-expansion-panels v-for="(item, index) in bollettini" class="mb-7">
      <v-expansion-panel elevation="0" class="rounded-lg">
        <v-expansion-panel-title class="justify-start align-start align-sm-center flex-column flex-sm-row">
          <v-container class="w-auto ma-0 py-1 py-sm-4 px-1 px-sm-4">
            <v-chip variant="outlined" class="w-auto px-3 py-1 text-indigo-darken-1 border-indigo" :class="[ index === 0 ? 'bg-blue-lighten-4' : 'bg-white']">
              <v-icon icon="mdi-calendar-range-outline" class="mr-2" />
              <v-container class="pa-0">{{ item.data }}</v-container>
            </v-chip>
          </v-container>
          <v-container class="w-auto ma-0 text-subtitle-1 py-1 py-sm-4 px-1 px-sm-4">
            {{ $t('home.bollettini.title') }} {{ $t(`home.bollettini.dayByIndex.${ getDayIndex(item.data) }`) }}
          </v-container>
          <v-container class="w-auto ma-0 text-body-2 py-1 py-sm-4 px-1 px-sm-4">
            {{ $t('home.bollettini.lastUpdate') }} {{ item.testo[0].last_update != '' ? getLastUpdate(item.testo[0].last_update) : '-' }}
          </v-container>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-container v-for="(testo) in item.testo" class="white-space-preline text-body-1 pa-0 pa-sm-4" v-html="testo.contenuto">
          </v-container>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

  </v-container>
</template>


<script lang="ts">
import { getDayIndexFromDate } from '@/utils/utils';
import { defineComponent } from 'vue';


export default defineComponent({
  name: "BollettiniComponent",
  props: ["bollettini"],
  data(): BollettiniDataInterface {
    return {}
  },
  methods: {
    getDayIndex(dataAsString: string): number {
      const data = new Date(dataAsString);
      return getDayIndexFromDate(data);
    },
    getLastUpdate(dataAsString: string): string {
      const data = new Date(dataAsString);
      return `${ data.getHours().toString().padStart(2, '0') }:${ data.getMinutes().toString().padStart(2, '0') } h`
    }
  },
})

interface BollettiniDataInterface {}

</script>